/**
 * Which lender's rules the Work Details screen applies (review I1).
 *
 * The session cache (`journeyLenderAtom`) is deliberately NOT an input: cpcore can move the journey
 * to its fallback lender during the work-details save itself, so the cache can still name the lender
 * the journey just left — and a no-work-email lender's rules would then hide the email for a lender
 * that requires it, looping the tenant between HomeScreen and Work Details.
 *
 * Order: the screen's own fresh `journey/full` read, then the key HomeScreen read from
 * `journey/full` just before routing here, else nothing → today's screen (work email shown).
 *
 * Dependency-free so node:test covers it: node --test src/b2b/lib/workDetailsLender.test.js
 */
import { DEFAULT_EMPLOYMENT_RULES, employmentRulesFor } from "./employmentRules.js";

const cleanKey = (value) => (typeof value === "string" && value.trim() ? value.trim() : null);

// `cached` is accepted only so callers can pass everything they hold; it is never used.
// eslint-disable-next-line no-unused-vars
export function pickWorkDetailsLenderKey({ fetched, fromHome, cached } = {}) {
  return cleanKey(fetched) ?? cleanKey(fromHome) ?? null;
}

/** The rules for that key; no key → today's rules (work email asked and verified). */
export function workDetailsRules(lenders, key) {
  return key ? employmentRulesFor(lenders, key) : DEFAULT_EMPLOYMENT_RULES;
}
